// Body descriptor
const body = document.getElementsByTagName('body')[0],
  modalWrapper = document.getElementsByClassName('modal')[0],
  // All buttons for modals
  modalButtons = document.querySelectorAll('[data-modal]'),
  // Modal window descriptor
  modalWindow = document.getElementById('contactModal'),
  // Modal close button
  modalClose = document.getElementsByClassName('modal__close')[0],
  // Modal window states
  modalWindowStates = {
    shown: 'modal_shown',
  };

// Close modal window
function closeModal() {
  modalWindow.classList.remove(modalWindowStates.shown);
  body.classList.remove('overflow-y-hidden');
}

for (let i = 0; i < modalButtons.length; i++) {
  modalButtons[i].addEventListener('click', function(event) {
    event.preventDefault();
    if (modalWindow.classList.contains(modalWindowStates.shown)) {
      closeModal();
    } else {
      modalWindow.classList.add(modalWindowStates.shown);
      body.classList.add('overflow-y-hidden');
    }
  });
}

// If modal presents on the page
if (modalClose !== undefined) {
  modalClose.addEventListener('click', function() {
    closeModal();
  });
}

// If modal presents on the page
if (modalWrapper !== undefined) {
  modalWrapper.addEventListener('click', function(event) {
    // If clicked on the background place
    if (event.target.classList.contains('modal')) {
      closeModal();
    }
  });
}
